import gsap from 'gsap';

export default function initHero() {
  const hero = document.querySelector('.hero');

  if (!hero) return;

  const hasSprinkles = hero.classList.contains('hero--animated-sprinkles');

  initBadge(hero);

  if (hasSprinkles) {
    const container = hero.querySelector('.hero__sprinkles');
    if (container) {
      // Ensure container has dimensions before proceeding
      if (container.offsetWidth === 0 || container.offsetHeight === 0) {
        requestAnimationFrame(() => initHero());
        return;
      }
      initSprinkles(container);
    }
  }

  function initBadge(hero) {
    const badge = hero.querySelector('.badge');
    if (!badge) return;

    gsap.to(badge, {
      keyframes: [
        {y: 0, duration: 0.4, ease: 'power2.in'},
        {y: -14, duration: 0.5, ease: 'power2.out'},
        {y: 0, duration: 0.4, ease: 'power2.in'},
        {y: -8, duration: 0.35, ease: 'power2.out'},
        {y: 0, duration: 0.3, ease: 'power2.in'}
      ],
      repeat: -1
    });
  }

  function initSprinkles(container) {
    const colors = [
      '#FF6B9A',
      '#FFD166',
      '#81ECEC',
      '#A29BFE',
      '#7BED9F'
    ];

    const count = 60;
    const minDistance = 100;
    const positions = [];
    const containerWidth = container.offsetWidth;
    const containerHeight = container.offsetHeight;
    const maxAttempts = 100;

    function getPosition() {
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        const x = Math.random() * 100;
        const y = Math.random() * 100;

        let valid = true;

        for (const p of positions) {
          const dx = (x - p.x) * containerWidth / 100;
          const dy = (y - p.y) * containerHeight / 100;

          if (Math.sqrt(dx * dx + dy * dy) < minDistance) {
            valid = false;
            break;
          }
        }

        if (valid) {
          positions.push({x, y});
          return {x, y};
        }
      }

      // If we can't find a valid position after max attempts, just place it anywhere
      const x = Math.random() * 100;
      const y = Math.random() * 100;
      positions.push({x, y});
      return {x, y};
    }

    for (let i = 0; i < count; i++) {
      const el = document.createElement('span');
      el.className = 'hero__sprinkles-sprinkle';

      const pos = getPosition();
      const baseRotation = gsap.utils.random(0, 180);

      gsap.set(el, {
        left: `${pos.x}%`,
        top: `${pos.y}%`,
        xPercent: -50,
        yPercent: -50,
        rotation: baseRotation,
        backgroundColor: gsap.utils.random(colors),
        opacity: gsap.utils.random(0.5, 0.9)
      });

      container.appendChild(el);

      const tl = gsap.timeline({
        repeat: -1,
        delay: gsap.utils.random(0, 4)
      });

      tl.to(el, {
        x: gsap.utils.random(-18, 18),
        y: gsap.utils.random(-18, 18),
        rotation: () => baseRotation + gsap.utils.random(-10, 10),
        duration: gsap.utils.random(3, 5),
        ease: 'sine.inOut'
      });

      tl.to(el, {
        x: 0,
        y: 0,
        rotation: baseRotation,
        duration: gsap.utils.random(3, 5),
        ease: 'sine.inOut'
      });
    }
  }
}
